import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';
import WaveTab from './fragmentWaveTab';

export default gql`
  mutation RemoveOrdersFromWave($input: RemoveOrdersFromWaveInput!) {
    removeOrdersFromWave(input: $input) {
      wave {
        ...WaveTab
      }
      orders {
        ...OrderRow
      }
    }
  }
  ${OrderRow}
  ${WaveTab}
`;



// WEBPACK FOOTER //
// ./src/queries/removeOrdersFromWave.js